import React from 'react'

import { navBarLogos } from 'branding/lender'
import { useBrandConfig } from 'contexts/BrandConfigContextProvider'
import { useLender } from 'contexts/LenderContextProvider'
import useUser from 'hooks/useUser'

import {
    NavbarContainer,
    NavbarContainerLogo,
    NavbarLink,
    NavbarLogo,
    NavbarNav,
    NavbarWrapper,
} from './Navbar.styled'
import NavbarDropdown from './NavbarDropdown/NavbarDropdown'
import NavbarItem from './NavbarItem'

export default function Navbar({
    children,
}: {
    readonly children?: React.ReactNode
}): JSX.Element {
    const { isAutoDealership } = useUser()
    const { name: lenderName } = useLender()
    const logoHref = isAutoDealership ? '#/dashboard' : '#'

    const { communicationName, navbarForceWhite, navbarLogoUrl } =
        useBrandConfig()

    const logoUrl = navBarLogos?.[lenderName]
        ? navBarLogos?.[lenderName]
        : navbarLogoUrl

    const logoAltText = navBarLogos?.[lenderName]
        ? lenderName
        : communicationName

    return (
        <NavbarWrapper isNavbarWhite={navbarForceWhite} role="navigation">
            <NavbarContainer>
                <NavbarContainerLogo>
                    <NavbarLink href={logoHref} data-testid="navbar-logo">
                        {logoUrl && (
                            <NavbarLogo alt={logoAltText} src={logoUrl} />
                        )}
                    </NavbarLink>
                </NavbarContainerLogo>
                <NavbarNav>{children}</NavbarNav>
            </NavbarContainer>
        </NavbarWrapper>
    )
}

Navbar.Item = NavbarItem
Navbar.Dropdown = NavbarDropdown
